import { Component, OnInit } from '@angular/core';
import { subdomain, s3Asset } from '@env/environment';

@Component({
  selector: 'app-session-expire-dialog',
  templateUrl: './session-expire-dialog.component.html',
  styleUrls: ['./session-expire-dialog.component.scss'],
})
export class SessionExpireDialogComponent implements OnInit {
  readonly s3Asset = s3Asset;
  constructor() {}

  ngOnInit(): void {}

  backToLogin() {
    window.location.href = `/?_subdomain=${subdomain}`;
  }
}
